import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-user-circle-icon]',
  template: `
    <svg:path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C1.28851e-07 3.58172 3.58172 1.28855e-07 8 0ZM4.98438 12.3633C4.49761 12.3634 4.04829 12.6073 3.78027 13.0039C4.91969 13.9657 6.39215 14.5459 8 14.5459C9.60785 14.5459 11.0803 13.9657 12.2197 13.0039C11.9517 12.6073 11.5024 12.3634 11.0156 12.3633H4.98438ZM8 1.4541C4.38505 1.4541 1.4541 4.38505 1.4541 8C1.4541 9.4765 1.94384 10.8385 2.76855 11.9336C3.31373 11.2925 4.11993 10.9093 4.98438 10.9092H11.0156C11.8801 10.9093 12.6863 11.2925 13.2314 11.9336C14.0562 10.8385 14.5459 9.4765 14.5459 8C14.5459 4.38505 11.615 1.4541 8 1.4541ZM8 2.5459C10.0082 2.5459 11.6366 4.17341 11.6367 6.18164C11.6367 8.18995 10.0083 9.81836 8 9.81836C5.99169 9.81836 4.36328 8.18995 4.36328 6.18164C4.36338 4.17341 5.99175 2.5459 8 2.5459ZM8 4C6.79507 4 5.81846 4.97674 5.81836 6.18164C5.81836 7.38663 6.79501 8.36328 8 8.36328C9.20499 8.36328 10.1816 7.38663 10.1816 6.18164C10.1815 4.97674 9.20493 4 8 4Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCircleIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
